import React, { useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const images = ['https://cdn.magicpatterns.com/uploads/vE9EV4wVGZK3FrgvdVRDf1/45f06f6a-15c5-48e6-85ad-dbb933e8e78a.png', 'https://cdn.magicpatterns.com/uploads/dBg8KgqrmUiowQq6jjWsLg/5267c97c-fa81-4f58-99a9-3a98bd6229b1.png', 'https://cdn.magicpatterns.com/uploads/hMhJ8i1dYLgCZ4pE7fP9Tj/e1639ddf-f840-443f-89cf-7c0041b26d63.png', 'https://cdn.magicpatterns.com/uploads/rCjHL7saCnNZ1ykPmgNno5/5c8c5abd-4c3b-493c-8e83-91496f219ed7.png', 'https://cdn.magicpatterns.com/uploads/3QrMfFaNYpNwS9SwGn19CS/6e8dc3e6-0b8a-4448-99fb-03e5d2c26f89.png'];
export function ImageCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const nextSlide = () => setCurrentIndex(prev => (prev + 1) % images.length);
  const prevSlide = () => setCurrentIndex(prev => (prev - 1 + images.length) % images.length);
  useEffect(() => {
    const timer = setInterval(nextSlide, 5000);
    return () => clearInterval(timer);
  }, []);
  return <div className="w-full bg-[#050505] py-4 sm:py-8" data-id="element-184">
      <div className="relative w-full max-w-2xl mx-auto aspect-square overflow-hidden bg-[#050505] rounded-none sm:rounded-2xl shadow-2xl" data-id="element-185">
        <AnimatePresence mode="wait" data-id="element-186">
          <motion.img key={currentIndex} src={images[currentIndex]} initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 0.5,
          ease: 'easeInOut'
        }} className="absolute inset-0 w-full h-full object-contain" alt={`Información de Limpia ${currentIndex + 1}`} data-id="element-187" />
        </AnimatePresence>

        {/* Controls */}
        <button onClick={prevSlide} className="absolute left-2 sm:left-4 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center rounded-full bg-black/50 text-white hover:bg-black/80 hover:scale-110 backdrop-blur-sm transition-all z-10 border border-white/10" data-id="element-188">
          <ChevronLeft className="w-6 h-6 pr-0.5" data-id="element-189" />
        </button>
        <button onClick={nextSlide} className="absolute right-2 sm:right-4 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center rounded-full bg-black/50 text-white hover:bg-black/80 hover:scale-110 backdrop-blur-sm transition-all z-10 border border-white/10" data-id="element-190">
          <ChevronRight className="w-6 h-6 pl-0.5" data-id="element-191" />
        </button>
      </div>
    </div>;
}